import React from 'react';
import Helmet from "react-helmet";
import DiscountInclude from '../../components/includes/discountInclude';
import PaymentMethodsInclude from '../../components/includes/paymentMethodsInclude';
import FAQinclude from '../../components/includes/FAQinclude';
import InfoPointsDDoS from './infoPoints';

class DDoSProtectionSwitzerland extends React.Component {

	render() {

		return (
			<React.Fragment>
				<Helmet>
					<title>DDoS Protection in Switzerland | Swiss Made Host</title>
					<meta name="description" content="Always-on network DDoS protection in Switzerland. Automatic mitigation for volumetric and L4 protocol floods included with dedicated and confidential servers." />
					<link rel="canonical" href="https://swissmade.host/en/ddos-protection-switzerland" />
				</Helmet>
				<div className="fullwidth pic ddos-protection">
					<div className="row">
						<div className="twelve columns">
							<div className="transparent">
								<h1 className="title">DDoS Protection in <span><i className="fa fa-plus-square" aria-hidden="true"></i> Switzerland</span></h1>
								<h2>Always-on mitigation for volumetric and protocol floods</h2>
							</div>
						</div>
					</div>
				</div>
				<DiscountInclude />
				<InfoPointsDDoS />
				<FAQinclude category={'ddos'} color={'light'} />
				<PaymentMethodsInclude />

			</React.Fragment>
		)
	}
}

export default DDoSProtectionSwitzerland;
